import { ReactNode, useEffect, useState } from 'react'

import {
  BackgroundReplacementProvider,
  MeetingProvider,
} from 'amazon-chime-sdk-component-library-react'
import { meetingConfigValue } from 'app/config/meeting'

import { AutoBackgroundReplacement } from './AutoBackgroundReplacement'

type Props = {
  children: ReactNode
}

export function MeetingProviderWrapper({ children }: Props): JSX.Element {
  const [backgroundImage, setBackgroundImage] = useState<Blob | undefined>()

  useEffect(() => {
    fetch('/bg-video-consultation.png')
      .then(res => res.blob())
      .then(setBackgroundImage)
      .catch(err => console.error('Failed to load background image:', err))
  }, [])

  return (
    <MeetingProvider {...meetingConfigValue}>
      <BackgroundReplacementProvider options={{ imageBlob: backgroundImage }}>
        <AutoBackgroundReplacement>{children}</AutoBackgroundReplacement>
      </BackgroundReplacementProvider>
    </MeetingProvider>
  )
}

export default MeetingProviderWrapper
